/**
 * withCoupons
 * HOC for wrapping the provided component with CouponsProvider
 */

import React from 'react'

import CouponsProvider from './coupons-provider'

export default function withCoupons (WrappedComponent) {
  return function CouponsProviderHOC(props) {
    return (
      <CouponsProvider>
        <WrappedComponent {...props} />
      </CouponsProvider>
    )
  }
}
